import { Button, Heading, Spacer, Switch } from '@sparemin/blockhead';
import React from 'react';

import AutomationPostModalBackButton from 'components/AutomationPostModalBackButton';

import InputLabel from 'components/Form/InputLabel';
import ModalContentWithMedia from 'components/Modal/ModalContentWithMedia';
import ShareFormGroup from 'components/ShareForm/ShareFormGroup';
import { Step } from 'components/SteppedModal';

import BlueskyCustomReplyAudiences from 'containers/BlueskyPostModal/BlueskyCustomReplyAudiences';
import BlueskyReplyLevelSelector from 'containers/BlueskyPostModal/BlueskyReplyLevelSelector';
import { BlueskyAutoPostModalSteps } from '../types';
import { block } from '../utils';
import { AdditionalDetails } from './types';

export interface UseAdditionalDetailsStepConfig {
  state: AdditionalDetails;
  onChange: (newAdditionalDetails: AdditionalDetails) => void;
  onBackClick?: () => void;
  onHideModal?: () => void;
  onSubmit?: () => void;
}

export default function useAdditionalDetailsStep({
  state,
  onChange,
  onBackClick,
  onHideModal,
  onSubmit,
}: UseAdditionalDetailsStepConfig): Step<BlueskyAutoPostModalSteps> {
  return {
    id: 'additional-details',
    hideFooter: true,
    replaceBody: true,
    component: (
      <>
        <ModalContentWithMedia
          className="composer-step-content"
          onClose={onHideModal}
        >
          <ModalContentWithMedia.ModalContentWithMediaColumn>
            <img
              src="https://static.sparemin.com/static/webapp-assets/auto-posting-detail/auto-posting-detail-bluesky-image-202506122020.png"
              className={block('composer-image')}
            />
          </ModalContentWithMedia.ModalContentWithMediaColumn>

          <ModalContentWithMedia.ModalContentWithMediaColumn className="composer-content-column">
            <Spacer
              orientation="vertical"
              align="flex-start"
              justify="center"
              space={2.5}
              className={block('additional-details-container')}
            >
              <AutomationPostModalBackButton
                text="Additional details"
                className={block('additional-details-button')}
                onClick={onBackClick}
              />

              <ShareFormGroup className={block('fluid-field')}>
                <InputLabel className={block('label')}>
                  Quote settings:
                </InputLabel>

                <Spacer
                  space="8px"
                  orientation="horizontal"
                  align="center"
                  justify="flex-start"
                >
                  <Heading level={4}>Allow quote posts</Heading>

                  <Switch
                    isSelected={state.allowQuotePost}
                    className={block('allow-quote-switch')}
                    onChange={value =>
                      onChange({
                        ...state,
                        allowQuotePost: value,
                      })
                    }
                  />
                </Spacer>
              </ShareFormGroup>

              <BlueskyReplyLevelSelector
                className={block('fluid-field')}
                selectClassName={block('fluid-field')}
                value={state.replyLevel}
                onChange={value => onChange({ ...state, replyLevel: value })}
              />

              <BlueskyCustomReplyAudiences
                value={state.customReplyAudiences}
                onChange={value =>
                  onChange({
                    ...state,
                    customReplyAudiences: value,
                  })
                }
              />
            </Spacer>

            <Button fluid onPress={onSubmit}>
              save changes
            </Button>
          </ModalContentWithMedia.ModalContentWithMediaColumn>
        </ModalContentWithMedia>
      </>
    ),
  };
}
